import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TimeSlot } from '@checkout/const';

@Component({
  selector: 'sd-time-slot-groups-tab',
  templateUrl: './time-slot-groups-tab.component.html',
  styleUrls: ['./time-slot-groups-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorTimeSlotGroupsTabComponent {
  @Input() timeSlot: TimeSlot;
  @Input() active: boolean;
}
